import React from 'react';
import PropTypes from 'prop-types';
import RichText from '../rich-text/base';
import Accordion from './accordion';

const AccordionAssembly = ({ contentfulData }) => (
  <Accordion header={contentfulData.heading}>
    <RichText richText={contentfulData.content} />
  </Accordion>
);

AccordionAssembly.propTypes = {
  contentfulData: PropTypes.object,
};

export default AccordionAssembly;
